import React from 'react'

const ToDos = () => {
  return (
    <div>
      <h1>Todos</h1>
      <p>Add Edit / Delete functionality</p>
      <p>Add <strong>Admin</strong> section for subjects and classes</p>
      <p>The card should be a separate component ... SOON</p>
      <p>Going for card designs... later</p>
      <p>TODO: Display current day, for daily overview</p>
      <p>For weekly overview group cards by day</p>
      <p>Display all cards is fine until there are too many of them...</p>
      <p>Clean up appbar: home instead of hamburger, get rid of all other stuff</p>
      <p>If you click on home while editing an entry, the form state will not clear. If you go
        to form, you will see that it's there. Not sure about further complications because of this...
      </p>
    </div>
  )
}

export default ToDos
